/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Or_Manual_InputInputs */

const vi_common_or_manual_input = /** @type {(inputs: Common_Or_Manual_InputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hoặc nhập tay`)
};

/**

* @param {Common_Or_Manual_InputInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const common_or_manual_input = /** @type {((inputs?: Common_Or_Manual_InputInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Or_Manual_InputInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_common_or_manual_input(inputs)
});